import styled from 'styled-components'
import {
  communicationContentWrapperCss,
  communicationRootCss,
} from '~/pages/communication/libs/communicationBaseStyles'
import { COLORS } from '~/shared/constants/uiConstants'

export const AgeCommunicationStyles = {
  Root: styled.div`
    ${communicationRootCss}
  `,

  ContentWrapper: styled.div`
    ${communicationContentWrapperCss}
    gap: 8px;
  `,

  TitleGroup: styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
  `,

  Title: styled.h1`
    font-family: 'Poppins', sans-serif;
    font-size: 21px;
    font-weight: 600;
    line-height: 1.5;
    text-align: center;
    color: ${COLORS.BLACK};
  `,

  Subtitle: styled.p`
    font-size: 15px;
    font-weight: 400;
    line-height: 1.3;
    text-align: center;
    color: #17202a;
  `,

  Options: styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-top: auto;
  `,

  OptionButton: styled.button<{ $isSelected?: boolean }>`
    width: 100%;
    padding: 20px 16px;
    background-color: ${({ $isSelected }) =>
      $isSelected ? '#ebf3ff' : COLORS.WHITE};
    border: 2px solid
      ${({ $isSelected }) => ($isSelected ? '#096ef9' : '#eaeaed')};
    border-radius: 16px;
    text-align: left;
    cursor: pointer;

    &:disabled {
      cursor: default;
    }
  `,

  OptionLabel: styled.span`
    font-family: 'Poppins', sans-serif;
    font-size: 15px;
    font-weight: 500;
    line-height: 1.3;
    color: ${COLORS.BLACK};
  `,
}
